class XAddMultipleProducts extends XThemeBaseElement {
  constructor() {
    super()
    this._onFormSubmit = this._onFormSubmit.bind(this)
  }
  mount() {
    /** @type {HTMLFormElement} */
    const form = document.createElement('form')
    this._form = form

    const mainProductFormId = this.getAttribute('data-product-form-id')
    const mainProductForm = mainProductFormId ? document.getElementById(mainProductFormId) : null
    this.mainProductForm = mainProductForm

    const formId = `form_addons_${Math.random().toString(36).slice(2)}`
    form.setAttribute('id', formId)
    form.addEventListener('submit', this._onFormSubmit, {
      signal: this._ac.signal,
    })
    document.body.appendChild(form)
    this.setAttribute('data-form-id', formId)

    const formElements = Array.from(
      this.querySelectorAll('[data-form-input], button[type="submit"')
    )
    for (let i = 0, l = formElements.length; i < l; i++) {
      const el = formElements[i]
      el.setAttribute('form', formId)
    }
  }

  _registerElement(el) {
    const formId = this.getAttribute('data-form-id')
    if (el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLButtonElement || el instanceof HTMLTextAreaElement) {
      el.setAttribute('form', formId)
    }

    const formElements = Array.from(
      this.querySelectorAll('[data-form-input], button[type="submit"')
    )
    for (let i = 0, l = formElements.length; i < l; i++) {
      const el = formElements[i]
      el.setAttribute('form', formId)
    }
  }

  /**
   *
   * @param {SubmitEvent} e
   */
  async _onFormSubmit(e) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.mainProductForm.checkValidity()) {
      this.mainProductForm.reportValidity()
      return
    }

    if (!this._form.checkValidity()) {
      this._form.reportValidity()
      return
    }

    const items = []

    // generate 8 char random string
    const randomBundleId = Math.random().toString(36).slice(2, 10) + '_' + Date.now()
    const mainProductFd = new FormData(this.mainProductForm)
    const props = { _bundle_id: randomBundleId }
    mainProductFd.forEach((value, key) => {
      if (key.startsWith('properties[')) {
        props[key] = value
      }
    })
    const mainProductJson = {
      id: +mainProductFd.get('id'),
      quantity: +mainProductFd.get('quantity') || 1,
      properties: props,
    }
    items.push(mainProductJson)

    const form = this._form
    const fd = new FormData(form)

    const iterator = fd.entries()
    let entry
    let i = 0

    // we assume that `quantity` input appear AFTER the variant input in the DOM. always!!
    while (!(entry = iterator.next()).done) {
      const [key, value] = entry.value

      if (key.startsWith('variant.id')) {
        entry = iterator.next()
        const [qtyKey, qtyValue] = entry.value
        // console.log({ varaint: value, qty: +qtyValue });
        const variantJson = {
          id: +value,
          quantity: +qtyValue,
          properties: {
            _parent_bundle_id: randomBundleId,
          },
        }
        items.push(variantJson)
      }

      i++
    }

    // const json = [...fd.entries()].map(([k, v]) => ({ [k]: v }));
    // fd.forEach((value, key) => {
    //   if (key.startsWith('variant.id')) {
    //     const qty = +fd.get(key.replace('variant.id', 'variant.qty'))
    //     if (qty > 0) {
    //       const variantJson = {
    //         id: +value,
    //         quantity: qty,
    //         properties: {
    //           _parent_bundle_id: randomBundleId,
    //         },
    //       }
    //       items.push(variantJson)
    //     }
    //   }
    // })

    console.log(items)

    document.dispatchEvent(new CustomEvent('theme:loading:start'))
    this.setAttribute('data-status', 'pending')
    return fetch(`/cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.reverse() }),
    })
      .then((r) => r.json())
      .then(() => {
        this.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: null, button: null, quantity: 0 },
          })
        )
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
        }, 800)
        this.setAttribute('data-status', 'idle success')
      })
  }

  unmount() {
    const form = this._form
    if (form) {
      form.remove()
    }
    this._form = null
  }
}

if (!customElements.get('x-add-multiple-products')) {
  customElements.define('x-add-multiple-products', XAddMultipleProducts)
}

class XProductItem extends XThemeBaseElement {
  constructor() {
    super()

    this._totalClones = 0
    this._variantItems = []
    this._selectedVariantItem = null
    this._featured_img_src = ''
    
    /**
     * @type {{
     *  addonParent: XAddMultipleProducts,
     *  field_vid: HTMLSelectElement,
     *  field_qty: HTMLInputElement,
     *  featured_img: HTMLImageElement | null,
     *  prices: {
     *    current: HTMLSpanElement,
     *    compare: HTMLSpanElement,
     *    total: HTMLSpanElement,
     *  },
     *  sku: HTMLSpanElement | null,
     *  duplicate_btn: HTMLButtonElement | null,
     *  main_product_form: HTMLFormElement | null,
     * }}
     */
    this.els = {
      addonParent: /** @type {any} */ (null),
      field_vid: /** @type {any} */ (null),
      field_qty: /** @type {any} */ (null),
      featured_img: /** @type {any} */ (null),
      prices: {
        current: /** @type {any} */ (null),
        compare: /** @type {any} */ (null),
        total: /** @type {any} */ (null),
      },
      duplicate_btn: /** @type {any} */ (null),
      main_product_form: /** @type {any} */ (null),
    }
    
    this.addonType = this.getAttribute('data-addon-type')

    // main (parent) product variant changed
    this._PICKET_CODES = {
      standard: '',
      doggie_picket: 'DG',
      double_picket: 'DP',
      full_double_picket: 'DPAR'
    }
  }

  mount() {
    this._cacheElements()
    const parent = this.closest('x-add-multiple-products')
    if (parent) {
      parent._registerElement(this)
    }

    this.addEventListener(
      'change',
      (e) => {
        e.stopPropagation()

        const target = e.target
        const name = target.getAttribute('data-form-input')
        const variantChanged = name === 'variant.id'

        // listen for variant id change
        if (variantChanged) {
          this._onVariantChange(e)
          return
        }
      },
      { signal: this._ac.signal }
    )

    this.addEventListener(
      'input',
      (e) => {
        e.stopPropagation()

        const target = e.target
        const name = target.getAttribute('data-form-input')
        const quantityChanged = name === 'variant.qty'

        // listen for quantity change
        if (quantityChanged) {
          this._onQuantityChange(e)
          return
        }
      },
      { signal: this._ac.signal }
    )

    if (this.els.duplicate_btn) {
      this.els.duplicate_btn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        if ((this._totalClones + 1) === this._variantItems.length) {
          return
        }

        this._totalClones++
        const clone = this.cloneNode(true)
        /** @type {HTMLElement} */
        let insertAfter = this
        while (insertAfter.nextElementSibling?.getAttribute('data-duplicate') === 'true') {
          insertAfter = insertAfter.nextElementSibling
        }

        clone.setAttribute('data-duplicate', 'true')
        insertAfter.insertAdjacentElement('afterend', clone)

        // max cloned
        if ((this._totalClones + 1) === this._variantItems.length) {
          this.setAttribute('data-max-cloned', 'true')
        }
      }, { signal: this._ac.signal })
    }

    this._onVariantChange()

    this._parent_product_codes = { color: null, picket: null }

    this.els.main_product_form.addEventListener('variant:change', e=> {
      this._onParentVariantChange(e.detail)
    })
    const lastVariantChangePayload = this.els.main_product_form._variantChangeEventPayload
    if (lastVariantChangePayload) this._onParentVariantChange(lastVariantChangePayload)
  }

  unmount() {
    this.els = {}
  }

  /**
   *
   * @returns {void}
   */
  _onVariantChange() {
    const variantField = this.els.field_vid
    const qtyField = this.els.field_qty
    const prices = this.els.prices

    const selectedVariantId = variantField.value || ''
    const selectedOption = selectedVariantId ? variantField.options[variantField.selectedIndex] : null
    const selectedSku = selectedOption ? selectedOption.getAttribute('data-sku') : ''
    this._selectedVariantItem = this._variantItems.find(x => x.id == selectedVariantId)

    this.setAttribute('data-vid', selectedVariantId)
    this.setAttribute('data-sku', selectedSku)
    this.els.sku.textContent = selectedSku

    if (selectedVariantId && selectedOption) {
      let maxQty = +selectedOption.getAttribute('data-inv-qty')
      let invManagement = selectedOption.getAttribute('data-inv-management')
      if (invManagement != 'shopify') {
        maxQty = 20_000
      }

      qtyField.max = maxQty
      let qtyValue = qtyField.valueAsNumber || 0
      if (qtyValue > maxQty) {
        qtyValue = 0
        qtyField.value = 0
      }

      // update image
      const imgEl = this.els.featured_img
      const img = selectedOption.getAttribute('data-image') || this._featured_img_src || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081'
      if (imgEl && imgEl.src != img) {
        imgEl.setAttribute('src', img)
      }

      // update price
      const price = parseInt(selectedOption.getAttribute('data-price'))
      prices.current.textContent = theme.Currency.formatMoney(price, window.theme.moneyFormat)
      prices.current.removeAttribute('hidden')
      this._updateTotalPrice(price, qtyValue)

      const cp = parseInt(selectedOption.getAttribute('data-compare-at-price') || 0)
      if (Number.isInteger(cp) && cp > 0) {
        prices.compare.textContent = theme.Currency.formatMoney(cp, window.theme.moneyFormat)
      }
      prices.compare.toggleAttribute('hidden', cp < 1)
    } else {
      prices.current.textContent = ''
      prices.compare.textContent = ''
      prices.current.setAttribute('hidden', '')
      prices.compare.setAttribute('hidden', '')
      prices.total.setAttribute('hidden', '')
      this._updateTotalPrice(0, 0)
    }

    this._canAddToCart()
  }

  /**
   *
   * @param {HTMLInputElement} qtyField
   * @returns {void}
   */
  _onQuantityChange() {
    const qtyField = this.els.field_qty

    let value = Math.max(Math.floor(qtyField.valueAsNumber), 0)
    if (Number.isNaN(value)) {
      value = 0
    }
    qtyField.value = value

    const variantField = this.els.field_vid
    // console.log({ onlyOneVariant, count: variantField.childElementCount })
    const selectedOption = variantField.value
      ? variantField.options[variantField.selectedIndex]
      : null

    // update total
    const price = selectedOption ? parseInt(selectedOption.getAttribute('data-price')) : 0
    this._updateTotalPrice(price, value)

    this._canAddToCart()
  }

  _updateTotalPrice(price, qty) {
    // update total
    const totalPrice = price * qty

    const prices = this.els.prices
    prices.total.textContent =
      totalPrice > 0 ? theme.Currency.formatMoney(totalPrice, window.theme.moneyFormat) : ''
    prices.total.toggleAttribute('hidden', totalPrice < 1)
  }

  /**
   *
   * @param {HTMLElement} rowItem
   * @returns {boolean}
   */
  _canAddToCart() {
    const qtyField = this.els.field_qty
    const vidField = this.els.field_vid

    const maxQty = +qtyField.max || 0
    const currentQty = qtyField.valueAsNumber || 0
    const isQtyValid = currentQty > 0 && currentQty <= maxQty

    const isVariantIdValid = !!vidField.value
    const canAddToCart = isQtyValid && isVariantIdValid

    this.setAttribute('data-can-add-to-cart', canAddToCart ? 'true' : 'false')

    const onlyOneVariant = vidField.childElementCount === 1

    if (canAddToCart) {
      qtyField.setAttribute('name', qtyField.getAttribute('data-name'))
      vidField.setAttribute('name', vidField.getAttribute('data-name'))

      vidField.required = !onlyOneVariant
    } else {
      qtyField.removeAttribute('name')
      vidField.removeAttribute('name')
      vidField.required = false
    }

    return canAddToCart
  }

  _cacheElements() {
    const parent = this.closest('x-add-multiple-products')

    if (!parent) {
      this.setAttribute('data-invalid', 'true')
      return
    }
    this.els.addonParent = parent

    const inputs = this.querySelectorAll('[data-form-input]')
    for (let i = 0, l = inputs.length; i < l; i++) {
      const el = inputs[i]
      const name = el.getAttribute('data-form-input')
      if (name === 'variant.id') {
        this.els.field_vid = el
      } else if (name === 'variant.qty') {
        this.els.field_qty = el
      }
    }

    const img = this.querySelector('img[data-featured-img]')
    this.els.featured_img = img || null

    const priceEl = this.querySelector('.x-add-multiple-products__addon-row-item--product-price')
    this.els.prices.current = priceEl.querySelector('[data-price]')
    this.els.prices.compare = priceEl.querySelector('[data-compare-at-price]')
    this.els.prices.total = this.querySelector('[data-total-price]')

    this.els.sku = this.querySelector('.x-add-multiple-products__addon-row-item--product-sku [data-sku]')

    this.els.duplicate_btn =
      this.getAttribute('data-duplicate') === 'true'
        ? null
        : this.querySelector('[data-duplicate-btn]') || null

    const allVariantOptions = this.els.field_vid.querySelectorAll('option[value][data-price]')
    for (let i = 0, l = allVariantOptions.length; i < l; i++) {
      const option = allVariantOptions[i]
      const variantId = option.value
      if (!variantId) continue

      let maxQty = +option.getAttribute('data-inv-qty')
      let invManagement = option.getAttribute('data-inv-management')
      if (invManagement != 'shopify' || Number.isNaN(maxQty)) {
        maxQty = 20_000
      }

      this._variantItems.push({
        id: +option.value,
        price: +option.getAttribute('data-price'),
        compare_at_price: +option.getAttribute('data-compare-at-price'),
        inventory_quantity: maxQty,
        inventory_policy: option.getAttribute('data-inv-policy'),
        inventory_management: invManagement,
        sku: option.getAttribute('data-sku'),
        image: option.getAttribute('data-image') || null,
      })

      this._selectedVariantItem = this._variantItems[0]
    }

    this._featured_img_src = this.getAttribute('data-featured-img-src') || ''

    const mainProductSection = this.closest('section[data-section-type="product"][data-section-id]')
    this.els.main_product_form = mainProductSection ? mainProductSection.querySelector('form.product-form') : null

    this.addonType = this.getAttribute('data-addon-type')

    let initialQty = this.getAttribute('data-initial-qty')
    if (initialQty) {
      initialQty = Math.max(0, parseInt(initialQty, 10))
      if (Number.isNaN(initialQty)) initialQty = 0

      this.els.field_qty.value = initialQty.toString()
    }
  }

  async _onParentVariantChange(variantChangeEventDetail) {
    const { variant, product } = variantChangeEventDetail || {} // new variant
    if (!variant || !product) return
    const isFence = (product.type || '').toLowerCase().trim().endsWith('fence')
    if (!isFence) return

    let variant_color_code = variant._fence_color

    if (typeof variant_color_code === 'undefined') {
      const sku_parts = variant.sku.split('_')
      variant_color_code = sku_parts.length > 1 ? sku_parts[1] : null
      variant._fence_color = variant_color_code
    }

    if (variant_color_code === null) {
      console.log(`no variant color code for variant ${variant.id}`, variant)
      return
    }

    let picket_style_code = variant._picket_style_code
    if (typeof picket_style_code === 'undefined') {
      const op2 = variant.option2.toLowerCase().trim()
      picket_style_code = this._PICKET_CODES[handleize(op2)] ?? null
    }
    
    if (picket_style_code === null) {
      console.log(`no picket style code for variant ${variant.id}`, variant)
      return
    }

    this._parent_product_codes.color = variant_color_code
    this._parent_product_codes.picket = picket_style_code

    const addonType = this.addonType
    // console.log(`(${addonType}) picket style code: ${picket_style_code}, variant color code: ${variant_color_code}`)

    if (addonType == 'posts' || addonType == 'gates') {
      const newAddonSku = detectNewAddonSku({ 
        addonType,
        color: this._parent_product_codes.color, 
        picketCode: this._parent_product_codes.picket, 
        sku: this._variantItems[0].sku 
      })
      
      this.setAttribute('data-new-addon-sku', newAddonSku)

      // if new sku does not exist - then refech
      const exist = this._variantItems.find(item => item.sku === newAddonSku)
      if (!exist) {
        // const listJso = fetchJson(`/search?q=sku:${newAddonSku}&view=x-json&type=product&page=1&limit=500`)
        const doc = await M.fetchHtml(`/search?q=${newAddonSku}&view=x-product-item&type=product&page=1&limit=500`)
        const el = (doc.querySelector(`x-product-item[data-sku="${newAddonSku}"]`) || doc.querySelector(`x-product-item option[data-sku="${newAddonSku}"]`).closest('x-product-item'))?.cloneNode(true)
        if (!this._connected) return
       
        if (el) {
          el.setAttribute('data-addon-type', addonType)
          el.setAttribute('data-initial-qty', this.els.field_qty.value || '0')
          requestAnimationFrame(() => {
            this.replaceWith(el)
          })
        }
      }
   
    } else if (addonType == 'gates') {

    }
  }
}

if (!customElements.get('x-product-item')) {
  customElements.define('x-product-item', XProductItem)
}

function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^-+|-+$/g, '')
}

/**
 * 
 * @param {string} sku 
 * @param {'posts' | 'gates'} addonType 
 * @returns 
 */
function parseSku(addonType, sku, ) {
  if (addonType == 'posts' || addonType == 'gates') {
    // sku: IDE-LPF2272_PDWHITE_R, IDE-LPF2272DG_PDWHITE_R, IDE-EPF2272DP_PDWHITE_R, IDE-CPF2272DPAR_PDGREEN_R
    if (sku.endsWith('_R')) sku = sku.slice(0, -2)

    const parts = sku.split('_')
    if (parts.length !== 2) {
      console.error(`Invalid SKU. Expected posts sku to have 2 parts, but got ${parts.length} parts (after removing '_R' from the end)`, sku)
      return null
    }
    let [pktCode, color] = parts
    if (pktCode.endsWith('DG')) pktCode = 'DG'
    else if (pktCode.endsWith('DP')) pktCode = 'DP'
    else if (pktCode.endsWith('DPAR')) pktCode = 'DPAR'
    else pktCode = ''


    return { pktCode, color }
  }


  console.log('Unknown addon type', addonType)
  return null
}

function detectNewAddonSku({color: colorProp, picketCode, addonType, sku: addonSku}) {
  
  if (addonType == 'posts' || addonType == 'gates') {
    // sku: IDE-LPF2272_PDWHITE_R, IDE-LPF2272DG_PDWHITE_R, IDE-EPF2272DP_PDWHITE_R, IDE-CPF2272DPAR_PDGREEN_R

    const parts = addonSku.split('_')
    let [model, color] = addonSku.split('_')
    if (!model || !color) {
      console.error(`Invalid SKU. Expected posts sku to have 2 parts, but got ${parts.length} parts (after removing '_R' from the end)`, addonSku)
      return null
    }

    if (model.endsWith('DG')) model = model.slice(0, -2)
    else if (model.endsWith('DP')) model = model.slice(0, -2)
    else if (model.endsWith('DPAR')) model = model.slice(0, -4)

    parts[0] = model+= picketCode
    parts[1] = colorProp

    return parts.join('_')
  }


  console.log('Unknown addon type', addonType)
  return null
}

// ----------------------------------------------------------------------------------------------------

const __stable_hash_weakmap = /* @__PURE__ */ new WeakMap();
let __stable_hash_l = 0;
function stable_hash(t) {
  const c = typeof t, s = t && t.constructor, f = s == Date;
  if (Object(t) === t && !f && s != RegExp) {
    let e = __stable_hash_weakmap.get(t);
    if (e)
      return e;
    e = ++__stable_hash_l + "~", __stable_hash_weakmap.set(t, e);
    let n;
    if (s == Array) {
      for (e = "@", n = 0; n < t.length; n++)
        e += stable_hash(t[n]) + ",";
      __stable_hash_weakmap.set(t, e);
    } else if (s == Object) {
      e = "#";
      const u = Object.keys(t).sort();
      for (; (n = u.pop()) !== void 0; )
        t[n] !== void 0 && (e += n + ":" + o(t[n]) + ",");
      __stable_hash_weakmap.set(t, e);
    }
    return e;
  }
  return f ? t.toJSON() : c == "symbol" ? t.toString() : c == "string" ? JSON.stringify(t) : "" + t;
}

async function fetchJson(url, fetchConfig) {
  return fetch(url, {
    headers: {
      accept: "application/json"
    },
    ...fetchConfig
  }).then((r) => r.json());
}
const htmlParser = new DOMParser();
async function fetchHtml(url, fetchConfig) {
  return fetch(url, fetchConfig).then((r) => r.text()).then((htmlText) => htmlParser.parseFromString(htmlText, "text/html"));
}
function memoize(fn, memoizedArgsIndices) {
  const CACHE = /* @__PURE__ */ new Map();
  return (...args) => {
    const key = stable_hash(
      typeof memoizedArgsIndices === "number" ? args.slice(0, memoizedArgsIndices + 1) : args
    );
    if (CACHE.has(key)) {
      return CACHE.get(key);
    }
    const result = fn(...args);
    if (result instanceof Promise) {
      result.catch((e) => {
        CACHE.delete(key);
        throw e;
      });
    }
    CACHE.set(key, result);
    return result;
  };
}
const M = {
  fetchHtml: memoize(fetchHtml, 0),
  fetchJson: memoize(fetchJson)
};

// TODO: Check and adjust max-quantity on duplicate entries
